<div class="btn-group btn-group-sm btn-group-toggle w-100" ngbRadioGroup name="{{field}}" [(ngModel)]="displayValue" (ngModelChange)="setValue($event)">
    <label ngbButtonLabel class="btn-outline-primary text-truncate" *ngFor="let option of options">
        <input ngbButton type="radio" [value]="option.value">{{option.name}} <span class="badge badge-warning" *ngIf="option.beta">Coming Soon</span>
    </label>
</div>
